import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import syncService from './services/databaseSync';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import Chatbot from './components/Chatbot';
import Footer from './components/Footer';
import WorkersPage from './pages/WorkersPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import AboutPage from './pages/AboutPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import MyBookingsPage from './pages/MyBookingsPage';
import PersonalDetailsPage from './pages/PersonalDetailsPage';
import SavedAddressesPage from './pages/SavedAddressesPage';
import SettingsPage from './pages/SettingsPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ScrollToTop from './components/ScrollToTop';
import './styles/variables.css';
import './styles/global.css';

const ENABLE_BIDIRECTIONAL_SYNC = process.env.REACT_APP_ENABLE_BIDIRECTIONAL_SYNC === 'true';

function SyncInitializer() {
  const { currentUser } = useAuth();

  useEffect(() => {
    if (!currentUser || !ENABLE_BIDIRECTIONAL_SYNC) return;

    // Sync is opt-in only. Running this in every client session can cause stale write conflicts.
    syncService.initializeBidirectionalSync();

    return () => {
      syncService.stopAllListeners();
    };
  }, [currentUser]);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <SyncInitializer />
        <div className="App">
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={
              <>
                <Hero />
                <Services />
                <HowItWorks />
              </>
            } />
            <Route path="/workers" element={<WorkersPage />} />
            <Route path="/services" element={<Services />} />
            <Route path="/service/:serviceName" element={<ServiceDetailPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/my-bookings" element={<MyBookingsPage />} />
            <Route path="/profile" element={<PersonalDetailsPage />} />
            <Route path="/saved-addresses" element={<SavedAddressesPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Routes>
          <Footer />
          <Chatbot />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
